module.exports = __webpack_public_path__ + "static/img/goods_icon_kuguang@2x.58084089.png";